(function ($) {

	function maybe_add_overflow() {

		$('.sidebar').each(function () {
			const $content = $(this).find('.sidebar__content');
			const content = $content.get(0);

			if (content) {
				if (content.scrollHeight > $content.innerHeight() + 5) {
					$(this).addClass('sidebar--scroll');
				} else {
					$(this).removeClass('sidebar--scroll');
				}
			}
		})
	}

	$(window).off('resize').on('resize', function () {
		maybe_add_overflow();
	});

	$(document).gp_ready(function () {
		maybe_add_overflow($('.sidebar'));
	});

})(jQuery);
